<div class="idle-dialog-general-container">
  <div class="idle-header-container">
    {{ 'idle_text_1' | t }}
  </div>
  <div class="idle-info-container">
    <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
      <ng-container *ngSwitchCase="'wettarena'">
        {{ 'idle_text_2_wa' | t }}
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ 'idle_text_2_b3000' | t }}
      </ng-container>
    </ng-container>
  </div>
  <div class="idle-buton-container">
    <div (click)="closeDialog()" class="btn colored register-button save-changes-button confirm-button flexible green">
      <div class="btn-text" style="color: #fff !important">
        {{ 'Confirm' | t }}
      </div>
    </div>
  </div>
</div>

<!-- <div class="mat-dark">
  <p>{{ 'inactive' | t}}</p>
<p class="idle-count">{{count}}</p>
  <button mat-stroked-button (click)="closeD()">{{'Ok' | t}}</button>
</div> -->
